import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
// MATERIAL
import { Grid, Typography } from "@mui/material";
// COMPONENTS
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";
// APIs
import { updateAdministrationTools } from "@/Settings/api/AdministrationTools/mutations";
import { errorLogger } from "@/Common/helpers/logger";
//PropTypes
import PropTypes from "prop-types";

// Options for the provider
const providerOptions = [{ value: "Podium" }, { value: "Auto Alert" }];

export default function ReputationManagementSelection(props) {
	const location = useSelector((state) => state.location.location);
	const locationId = location?.locationId;

	/******************************************************* MUTATIONS ********************************************************/
	const { mutate: mutateRepManagementProvider, isPending: isLoadingRepManagementProvider } = useMutation({
		mutationKey: ["mutateRepManagementProvider", locationId],
		mutationFn: (input) => updateAdministrationTools(locationId, input),
	});

	/******************************************************* HANDLERS ********************************************************/
	// Fn that handles when the user selects a provider
	const handleChange = (option) => {
		const input = {
			integrations: {
				...props.settings?.integrations,
				reputationManagement: {
					...props.settings?.integrations?.reputationManagement,
					provider: option?.value,
				},
			},
		};
		mutateRepManagementProvider(input);
	};

	const reputationManagementProvider = props.settings?.integrations?.reputationManagement?.provider;

	return (
		<Grid container direction="column" spacing={2} marginTop={"-5px"} marginBottom={"36px"}>
			<Grid item>
				<Typography className="regular-montserrat-label !text-[16px] !mb-[12px]">{props.title}</Typography>
				<SmartSelector
					selectBy="value"
					showBy="value"
					options={providerOptions}
					selected={reputationManagementProvider ? { value: reputationManagementProvider } : null}
					inputProps={{
						placeholder: "Select Provider",
					}}
					clearable
					disabled={isLoadingRepManagementProvider}
					loading={isLoadingRepManagementProvider}
					sx={{ width: "200px" }}
					onChangeAction={handleChange}
				/>
			</Grid>
		</Grid>
	);
}

ReputationManagementSelection.propTypes = {
	settings: PropTypes.object,
	title: PropTypes.string,
};
